import Vue from 'vue';

/**
 * One short status line for the assistant ("Copied", "Conversation deleted · Undo"). AvaAssistant
 * renders it; any assistant component calls showToast(). One message at a time; an optional action
 * (Undo) keeps it on screen a little longer and makes it clickable.
 */
export const toastState = Vue.observable({ text: '', visible: false, action: null });

const SHOW_MS = 2000;
/** How long an actionable toast (Undo) stays: the same window the action has to be taken in. */
export const ACTION_TOAST_MS = 5000;
let timer = null;

export function hideToast() {
  clearTimeout(timer);
  toastState.visible = false;
  toastState.action = null;
}

/**
 * @param {string} text
 * @param {{ action?: { label: string, run: () => void } }} [options]
 */
export function showToast(text, { action = null } = {}) {
  toastState.text = text;
  toastState.action = action;
  toastState.visible = true;
  clearTimeout(timer);
  timer = setTimeout(hideToast, action ? ACTION_TOAST_MS : SHOW_MS);
}

/** Runs the toast's action (once) and hides it. */
export function runToastAction() {
  const { action } = toastState;
  hideToast();
  if (action) action.run();
}
